<style src="./ReportParkedNotified.scss" lang="scss"></style>
<template>
  <section>
    <spinner v-if="showSpinner" />
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <th>Entrada</th>
          <th>Placa</th>
          <th>Estacionamento</th>
          <th>Qt Débitos</th>
          <th>Débito R$</th>
        </thead>
        <tbody>
          <tr class="read" v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.startTime | fillTime }}</td>
            <td>{{ item.licencePlate | formatLicencePlate }}</td>
            <td>{{ item.actualPlace[0] }}</td>
            <td>{{ item.countDebits }}</td>
            <td>{{ item.totalDebits | totalToCurrencyBR }}</td>
            <td>
              <div class="notifycode" @click="openImage(idx)">
                <i class="fa fa-arrow-right"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        pageSkip: 0,
        pageLimit: 30,
        isParked: true,
      },
      resultList: [],
    };
  },
  filters: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    formatLicencePlate(licencePlate) {
      return licencePlate.toUpperCase();
    },
    totalToCurrencyBR(value) {
      if (!value) {
        return '-';
      }
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
  },
  mounted() {
    this.filterReport();
  },
  methods: {
    async filterReport() {
      this.showSpinner = true;
      this.resultList = [];

      const query = {
        ...this.form,
      };

      try {
        const reports = await this.$store.dispatch(
          'REPORTS/ReportParkedNotified',
          {
            query,
          },
        );

        this.resultList = reports;
      } catch (error) {
        console.error(error);
      } finally {
        this.showSpinner = false;
      }
    },
    nextPage() {},
    previousPage() {},
    openImage(itemIndex) {
      const licencePlate = this.resultList[itemIndex].licencePlate;
      let routeData = this.$router.resolve({
        name: 'VehicleHistoryWithLicencePlate',
        params: { licencePlate },
      });
      window.open(routeData.href, '_blank');

      // const photoPath = this.resultList[itemIndex].vehiclePhoto[0].replace(
      //   '/var/app/server-user-manager/notify-photos/',
      //   '',
      // );
      // const photoPath = this.resultList[itemIndex].vehiclePhoto[0];
      // window.open(`https://estacion.app:3000/${photoPath}`);
      // window.open(`http://localhost:3000/${photoPath}`);
    },
  },
};
</script>